import api from './client'

export const magentoApi = {
  test: () => api.get('/magento/test'),
  testCustom: () => api.get('/magento/test-custom'),
  importarPedidos: () => api.post('/magento/importar-pedidos'),
  debugProcessing: () => api.get('/magento/debug-processing'),
  debugPedido: (incrementId) => api.get('/magento/debug-pedido', { params: { increment_id: incrementId } }),
}
